@if (loading) {
  <mat-spinner color="primary" [diameter]="30"></mat-spinner>
} @else {
  <button class="button button--primary" mat-button [class.button--large]="size === 'large'">{{ 'COMMON.load_more' | translate }}</button>
}
